import { INameObject } from './index';
import { ITokenType } from '../REST';

export interface IGetAcceptanceDocuments {
    data?: IGetAcceptanceDocumentsItemAPI[];
}
export interface IGetAcceptanceDocumentsItemAPI {
    id: string;
    type: 'acceptance_document';
    attributes?: {
        domain?: IAcceptanceDocumentsDomain;
        name?: string;
        content_file_url?: string;
    };
}

export interface IAcceptanceDocumentsItem extends INameObject {
    fileName?: string;
    domain?: IAcceptanceDocumentsDomain;
    isAccept?: boolean;
    contentFileUrl?: string;
}

export type AuthTokenTypes = { [k in ITokenType]?: string };

type IAcceptanceDocumentsDomain = 'terms_and_conditions' | 'privacy_policy';

export enum AppStatus {
    INITIALIZATION = 'INITIALIZATION', // Only Start spinner
    GET_USER_INFO = 'GET_USER_INFO', // Fake Status ????
    AUTHORIZATION = 'AUTHORIZATION', // Login or Signup
    ACCEPT_POLICY = 'ACCEPT_POLICY',
    READY = 'READY',
}

// Token OK           - INITIALIZATION->GET_USER_INFO->READY
// Token NO           - INITIALIZATION->GET_USER_INFO-x->AUTHORIZATION->GET_USER_INFO->READY
// Policy NOT + Token - INITIALIZATION->GET_USER_INFO-x->ACCEPT_POLICY->GET_USER_INFO->READY
// Policy NOT         - INITIALIZATION->GET_USER_INFO-x->AUTHORIZATION->GET_USER_INFO-x->ACCEPT_POLICY->GET_USER_INFO->READY
// Loss Policy Work   - GET_NNN-x->ACCEPT_POLICY->GET_USER_INFO->READY->GET_CARD_NNN
// LogOut             - AUTHORIZATION

// GET_USER_INFO(or GET_NNN) -> Ok
// GET_USER_INFO(or GET_NNN) -x-> Bad token  -> AUTHORIZATION
// GET_USER_INFO(or GET_NNN) -x-> Bad policy -> ACCEPT_POLICY
